import {
  logo3,
  logo1,
  bg4,
  iconMail,
  iconPhone,
  iconLocation,
} from "../assets";
import useDevice from "../util";

const Contact = () => {
  const device = useDevice();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="w-screen bg-white flex items-center flex-col">
      <div className="w-[100vw] min-h-[88px] bg-[#005DD7] flex justify-center flex-col sm:flex-row">
        <div className="flex sm:w-[1116px] flex-col sm:flex-row items-center justify-between py-[24px] lg:py-0">
          <div className="flex flex-col sm:flex-row items-center">
            <img src={logo3} alt="" />
            <div className="text-[#ffffff] text-[24px] sm:text-[30px] lg:text-[36px] font-[400] text-center">
              {device === "mobile"
                ? "Sống theo phong cách của bạn"
                : "- Sống theo phong cách của bạn"}
            </div>
          </div>
          <div
            onClick={() => scrollToTop()}
            className="text-[#005dd7] text-[18px] lg:text-[20px] font-[600] w-[356px] sm:w-[342px] lg:w-[356px] h-[58px] flex items-center justify-center bg-white rounded-[10px] cursor-pointer mt-[24px] sm:mt-0"
          >
            Tham gia cùng chúng tôi
          </div>
        </div>
      </div>

      <div className="w-[100vw] min-h-[484px] relative flex justify-center">
        <img
          className="object-cover absolute z-[0] w-screen top-0 h-[100%]"
          src={bg4}
          alt=""
        />
        <div className="w-[1156px] px-[20px] z-[2] flex flex-col items-center sm:items-start">
          <img className="w-[270px] h-[78px] mb-[40px]" src={logo1} alt="" />
          <div className="w-full flex justify-between flex-col items-center sm:flex-row gap-[20px]">
            <div className="flex flex-col items-center max-w-[355px] h-full">
              <img className="w-[121px] mb-[17px]" src={iconLocation} alt="" />
              <div className="text-contact-1 mb-[17px]">
                Tổng Công ty Bảo Việt Nhân thọ
              </div>
              <div className="text-contact-2">Trụ sở văn phòng: </div>
              <div className="text-contact-3 text-center">
                Tầng 5, 79 Lý Thường Kiệt, Hoàn Kiếm, Hà Nội
              </div>
            </div>
            <div className="flex flex-col items-center max-w-[355px] h-full">
              <img className="w-[121px] mb-[17px]" src={iconPhone} alt="" />
              <div className="text-contact-1 mb-[17px]">
                Tổng đài Chăm sóc Khách hàng
              </div>
              <div className="text-contact-3 ">*1166 hoặc 1900 558899</div>
              <div className="text-contact-3  text-center">nhánh số 4</div>
            </div>
            <div className="flex flex-col items-center max-w-[355px] h-full">
              <img className="w-[121px] mb-[17px]" src={iconMail} alt="" />
              <div className="text-contact-1 mb-[17px]">Email</div>
              <div className="text-contact-3">
                life-tsc-ptkd-lifepro@baoviet.com.vn
              </div>
            </div>
          </div>
        </div>
        <div className="text-[#ffffff] text-[14px] font-[500]  absolute bottom-[18px]">
          Copyright © 2021 Tập đoàn Bảo Việt.
        </div>
      </div>
    </div>
  );
};

export default Contact;
